// V_CC_CART_29 | 3 Pair Bundle - Multi Color Pair Upsell
// snippets/buy-buttons.liquid only flags whether the product being added
// belongs to the eligible collection (a stable, cart-independent fact).
// Whether THIS add should actually be tagged as the qualifying 4th pair —
// bundle already in cart? nothing else tagged yet? — is decided here, live,
// at the moment the add-to-cart request is sent (see the fetch override
// below), since that's the only point guaranteed not to be stale. The
// correct variant-specific key is written directly at that point:
//
// Var A: tagged as `_cart29_qualifying_pair`. A separate discount function
// the client built reads this property directly to apply a flat $15 price.
//
// Var B: tagged as `_cart29_qualifying_pair_b`. That same discount function
// reads this key too (with its own 15% rate) — this file does ONLY the
// tagging/untagging, no discount code of any kind is applied here.
// (Previously Var B applied a manual "4-PAIR-DISCOUNT" Buy-X-Get-Y code via
// the Cart API — dropped because that discount type has no concept of "only
// discount 1 unit": it discounted every matching collection item in the
// cart, not just the tagged one. The property-based discount function
// doesn't have that problem, since it only ever looks at the specific
// tagged line.)
//
// Control (neither test class present): must never carry either tag, since
// Control should be completely unaffected by this test.
//
// QA note: testers switch the forced variant (Control / Var A / Var B)
// within the SAME cart while validating before launch. Every sync path
// below converts an EXISTING tagged line to match whatever variant is
// CURRENTLY active — so switching in any order always converges to the
// right state, instead of leaving behind whatever a previously-tested
// variant left in the cart.
(function () {
  var PLAIN_PROPERTY = "_cart29_qualifying_pair";
  var B_PROPERTY = "_cart29_qualifying_pair_b";
  var ELIGIBLE_MARKER = "_c_cart29_eligible_product";

  var domLoaded = false;
  var igReady = false;
  var initialized = false;
  var syncing = false;
  var variant = null; // "a" | "b" | null (Control)

  // buy-buttons.liquid only flags collection membership (ELIGIBLE_MARKER) —
  // a fact about the product that's stable across page loads. Liquid can't
  // safely decide "is the bundle in cart / is something already tagged"
  // itself: that state can change elsewhere (e.g. the bundle gets added via
  // the cart drawer) without this page ever reloading, so a decision baked
  // in at render time can go stale in either direction — under-tagging (the
  // bundle arrived after this page rendered) or over-tagging (clicking Add
  // again on the same page after already qualifying). So every add that
  // carries the marker gets a live cart check here, at request time, which
  // is the only point that can't be stale — and the correct variant-specific
  // key is written directly, with no separate rename-after-send step needed.
  var origFetch = window.fetch;
  window.fetch = function (url, options) {
    if (
      typeof url === "string" &&
      /\/cart\/add\.js/.test(url.split("?")[0]) &&
      options &&
      options.body instanceof FormData
    ) {
      var formData = options.body;
      if (formData.has(ELIGIBLE_MARKER)) {
        formData.delete(ELIGIBLE_MARKER);
        return origFetch("/cart.js")
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var hasBundle = cartHasBundle(cart);
            var alreadyTagged = findTaggedLine(cart, PLAIN_PROPERTY) || findTaggedLine(cart, B_PROPERTY);
            if (hasBundle && !alreadyTagged) {
              var key = variant === "b" ? B_PROPERTY : PLAIN_PROPERTY;
              formData.set("properties[" + key + "]", "true");
            }
            return origFetch.call(window, url, options);
          });
      }
    }
    return origFetch.apply(window, arguments);
  };

  function cartHasBundle(cart) {
    return cart.items.some(function (item) {
      return item.title.indexOf("3 Pairs") !== -1;
    });
  }

  function findTaggedLine(cart, property) {
    return cart.items.find(function (item) {
      return item.properties && item.properties[property];
    });
  }

  function refreshCartUI() {
    fetch(window.location.pathname + "?sections=cart-drawer")
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        if (!sections["cart-drawer"]) return;
        var parser = new DOMParser();
        var newDoc = parser.parseFromString(sections["cart-drawer"], "text/html");
        var newItems = newDoc.querySelector(".cart-drawer__line-items");
        var oldItems = document.querySelector(".cart-drawer__line-items");
        if (newItems && oldItems) oldItems.innerHTML = newItems.innerHTML;
        var newTotal = newDoc.querySelector(".c-cart-total-price-container");
        var oldTotal = document.querySelector(".c-cart-total-price-container");
        if (newTotal && oldTotal) oldTotal.innerHTML = newTotal.innerHTML;
      });
  }

  function setLineProperties(line, properties) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: line.key,
        quantity: line.quantity,
        properties: properties
      })
    }).then(function (r) { return r.json(); });
  }

  function finishSync(promise) {
    promise
      .then(function () {
        syncing = false;
        refreshCartUI();
      })
      .catch(function () {
        syncing = false;
      });
  }

  // Tag/untag logic is identical for both variants — only the property key
  // (and which key counts as "the other one," for QA variant-switching)
  // differs.
  function syncTaggedVariant(cart, ownProperty, otherProperty) {
    var hasBundle = cartHasBundle(cart);
    var otherTagged = findTaggedLine(cart, otherProperty);

    // Coming from the other variant (QA switched groups mid-cart): convert
    // the tag to this variant's key.
    if (otherTagged) {
      syncing = true;
      var convertProps = {};
      convertProps[otherProperty] = null;
      convertProps[ownProperty] = "true";
      finishSync(setLineProperties(otherTagged, convertProps));
      return;
    }

    // Anti-cheat: bundle removed but a line is still tagged — untag it.
    var ownTagged = findTaggedLine(cart, ownProperty);
    if (hasBundle || !ownTagged) return;

    syncing = true;
    var clearProps = {};
    clearProps[ownProperty] = null;
    finishSync(setLineProperties(ownTagged, clearProps));
  }

  function syncVarA(cart) {
    syncTaggedVariant(cart, PLAIN_PROPERTY, B_PROPERTY);
  }

  function syncVarB(cart) {
    syncTaggedVariant(cart, B_PROPERTY, PLAIN_PROPERTY);
  }

  function syncControl(cart) {
    var plainTagged = findTaggedLine(cart, PLAIN_PROPERTY);
    var bTagged = findTaggedLine(cart, B_PROPERTY);

    if (!plainTagged && !bTagged) return;

    syncing = true;
    var chain = Promise.resolve();
    if (plainTagged) {
      var clearPlain = {};
      clearPlain[PLAIN_PROPERTY] = null;
      chain = chain.then(function () { return setLineProperties(plainTagged, clearPlain); });
    }
    if (bTagged) {
      var clearB = {};
      clearB[B_PROPERTY] = null;
      chain = chain.then(function () { return setLineProperties(bTagged, clearB); });
    }
    finishSync(chain);
  }

  function sync(cart) {
    if (!cart || syncing) return;
    if (variant === "b") syncVarB(cart);
    else if (variant === "a") syncVarA(cart);
    else syncControl(cart);
  }

  function init() {
    if (initialized || !domLoaded || !igReady) return;
    initialized = true;

    if (document.body.classList.contains("c-cart29VarB")) {
      variant = "b";
    } else if (document.body.classList.contains("c-cart29VarA")) {
      variant = "a";
    }

    fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(sync);

    document.addEventListener("cart:change", function (e) {
      sync(e.detail && e.detail.cart);
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    domLoaded = true;
    init();
  });
  window.addEventListener("ig:ready", function () {
    igReady = true;
    init();
  });
  if (document.readyState !== "loading") {
    domLoaded = true;
    init();
  }

  // Intelligems custom events — tracked regardless of variant/bucket.
  function pushIgEvent(eventName) {
    window.igEvents = window.igEvents || [];
    window.igEvents.push({ event: eventName });
  }

  // Whole card is clickable (not just the CTA), same destination either way.
  document.addEventListener("click", function (e) {
    var card = e.target.closest(".c-cart29-upsell");
    if (!card) return;

    pushIgEvent("upgrade_module_click");

    if (e.target.closest("a")) return; // the CTA link navigates on its own
    var cta = card.querySelector(".c-cart29-upsell__cta");
    if (cta) window.location.href = cta.href;
  });

  document.addEventListener("variant:add", function (e) {
    var items = (e.detail && e.detail.items) || [];
    var addedBundle = items.some(function (item) {
      return item.title && item.title.indexOf("3 Pairs") !== -1;
    });
    if (addedBundle) {
      pushIgEvent("Add_3pair-bundle");
    }
  });
})();
